import React from "react";
function Pre() {
  return <div id='preloader'></div>;
}

export default Pre;
